var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M26.1544 6.5625C28.3794 7.1609 30.4081 8.33343 32.0374 9.96265C33.6666 11.5919 34.8391 13.6206 35.4375 15.8456",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M24.7953 11.6349C26.1303 11.9939 27.3475 12.6974 28.3251 13.675C29.3026 14.6525 30.0061 15.8697 30.3651 17.2047",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M15.1719 20.4775C16.5333 23.2608 18.7895 25.5068 21.5791 26.8555C21.7832 26.9522 22.0089 26.9941 22.2342 26.9771C22.4594 26.9601 22.6763 26.8847 22.8635 26.7584L26.9709 24.0194C27.1525 23.8983 27.3616 23.8244 27.579 23.8044C27.7964 23.7845 28.0154 23.819 28.2161 23.9051L35.9003 27.1983C36.1613 27.3092 36.3792 27.5019 36.5212 27.7474C36.6632 27.9929 36.7216 28.2779 36.6875 28.5595C36.4446 30.46 35.5173 32.2068 34.0793 33.4728C32.6412 34.7389 30.791 35.4373 28.875 35.4374C22.9574 35.4374 17.2821 33.0867 13.0977 28.9023C8.91327 24.7179 6.5625 19.0426 6.5625 13.1249C6.5626 11.209 7.26107 9.35875 8.52712 7.92068C9.79317 6.48262 11.54 5.55533 13.4405 5.31246C13.722 5.27838 14.007 5.33673 14.2526 5.47872C14.4981 5.6207 14.6908 5.83863 14.8017 6.09966L18.0978 13.7906C18.183 13.9895 18.2178 14.2064 18.1989 14.422C18.18 14.6376 18.1081 14.8452 17.9896 15.0263L15.2602 19.1967C15.136 19.3844 15.0625 19.601 15.047 19.8255C15.0316 20.0499 15.0746 20.2746 15.1719 20.4775V20.4775Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneCall);
export default __webpack_public_path__ + "static/media/phoneCall.7dd9f23cdd3bed4d1327b8889e46dd36.svg";
export { ForwardRef as ReactComponent };